import { TitleStyleInterface } from './title-style.interface';
import { TitleDarkTheme } from './title.dark-theme';

export const TitleLightTheme: TitleStyleInterface = TitleDarkTheme;
